var count = 0;

var LIMIT = 10;

export const addAccessibilityToAudioPlayer = () => {
    if (
        document.querySelector(".rc-slider-handle") &&
        document.querySelector(".audio-player-action-btns") &&
        document.querySelector(".audio-player-action-btns").children &&
        document.querySelector(".audio-player-action-btns").children.length &&
        document.querySelector(".audio-player-extras-action") &&
        document.querySelector(".audio-player-extras-action").children &&
        document.querySelector(".audio-player-extras-action").children.length &&
        document.querySelector(".audio-list") &&
        document.querySelector(".audio-list").children &&
        document.querySelector(".audio-list").children.length
    ) {
        const actionButtonLength = document.querySelector(".audio-player-action-btns").children.length;
        const extraActionLength = document.querySelector(".audio-player-extras-action").children.length;
        const audioListLength = document.querySelector(".audio-list").children.length;

        document.querySelector(".rc-slider-handle").setAttribute("tabindex", "0");
        document.querySelector(".rc-slider-handle").setAttribute("role", "button");
        document.querySelector(".rc-slider-handle").addEventListener("focus", function () {
            this.style.color = "#FFFFFF";
            this.style.border = "#FFFFFF solid 2px";
        });
        document.querySelector(".rc-slider-handle").addEventListener("blur", function () {
            this.style.color = "#FFEEAA";
            this.style.border = "none";
        });
        document.querySelector(".rc-slider-handle").addEventListener("keypress", function (event) {
            if (event.key === "Enter") {
                event.preventDefault();
                document.querySelector(".rc-slider-handle").click();
            }
        });
        for (let i = 0; i < actionButtonLength; i++) {
            document.querySelector(".audio-player-action-btns").children[i].setAttribute("tabindex", "0");
            document.querySelector(".audio-player-action-btns").children[i].setAttribute("type", "button");
            document.querySelector(".audio-player-action-btns").children[i].addEventListener("focus", function () {
                this.style.color = "#FFFFFF";
                this.style.border = "#FFFFFF solid 2px";
            });
            document.querySelector(".audio-player-action-btns").children[i].addEventListener("blur", function () {
                this.style.color = "#FFEEAA";
                this.style.border = "none";
            });
            document.querySelector(".audio-player-action-btns").children[i].addEventListener("keypress", function (event) {
                if (event.key === "Enter") {
                    event.preventDefault();
                    document.querySelector(".audio-player-action-btns").children[i].click();
                }
            });
        }
        for (let i = 0; i < extraActionLength; i++) {
            document.querySelector(".audio-player-extras-action").children[i].setAttribute("tabindex", "0");
            document.querySelector(".audio-player-extras-action").children[i].setAttribute("role", "button");
            document.querySelector(".audio-player-extras-action").children[i].addEventListener("focus", function () {
                this.style.color = "#FFFFFF";
                this.style.border = "#FFFFFF solid 2px";
            });
            document.querySelector(".audio-player-extras-action").children[i].addEventListener("blur", function () {
                this.style.color = "#FFEEAA";
                this.style.border = "none";
            });
            document.querySelector(".audio-player-extras-action").children[i].addEventListener("keypress", function (event) {
                if (i === 1) {
                    if (event.key === "Enter") {
                        event.preventDefault();
                        document.querySelector(".volume-icon-wrapper").click();
                    }
                } else {
                    if (event.key === "Enter") {
                        event.preventDefault();
                        document.querySelector(".audio-player-extras-action").children[i].click();
                    }
                }
            });
        }
        for (let i = 0; i < audioListLength; i++) {
            document.querySelector(".audio-list").children[i].setAttribute("tabindex", "0");
            document.querySelector(".audio-list").children[i].setAttribute("role", "button");
            document.querySelector(".audio-list").children[i].addEventListener("focus", function () {
                this.style.border = "#FFFFFF solid 2px";
            });
            document.querySelector(".audio-list").children[i].addEventListener("blur", function () {
                this.style.border = "none";
            });
            document.querySelector(".audio-list").children[i].addEventListener("keypress", function (event) {
                if (event.key === "Enter") {
                    event.preventDefault();
                    document.querySelector(".audio-list").children[i].click();
                }
            });
        }
    } else {
        if (count < LIMIT) {
            setTimeout(() => addAccessibilityToAudioPlayer(), 500);
        }
        count = count + 1;
    }
}